import type { ImportPatentsStatus } from '../repositories/import-patents-repository';
import type { Event } from '@patsnap/tahiti-core';
import type { WorkspaceInfo } from '../types';

export const FtoReportImportPatentsService = Symbol.for('FtoReportImportPatentsService');

export interface ImportPatentsOptions {
    spaceId?: string;
    folderId?: string;
    batchSize?: number;
}

export interface FtoReportImportPatentsService {

    /**
     * 导入专利开始事件
     */
    onImportPatentsStart: Event<ImportPatentsStatus>;
    /**
     * 导入专利进度事件
     */
    onImportPatentsProgress: Event<ImportPatentsStatus>;
    /**
     * 导入专利完成事件
     */
    onImportPatentsComplete: Event<ImportPatentsStatus>;

    /**
     * 导入专利
     * @param folderId 文件夹ID
     * @param batchSize 批量大小
     * @returns 导入专利异步任务状态
     */
    importPatents(options?: ImportPatentsOptions): Promise<ImportPatentsStatus>;

    /**
     * 检查导入专利
     * @returns 导入专利异步任务状态
     */
    checkImportPatents(): Promise<ImportPatentsStatus>;

    /**
     * 获取工作空间信息
     * @returns 工作空间信息
     */
    syncWorkspaceInfo(): Promise<WorkspaceInfo | undefined>;
    /**
     * 更新工作空间信息
     */
    updateWorkspaceInfo(wsInfo: WorkspaceInfo): Promise<void>;

    /**
     * 释放资源
     */
    dispose(): void;
}
